// Helpers de precios y prueba de Pro. Los precios llegan de GET /api/planes.

/** "Prueba de Pro: quedan 5 días" */
export const textoPrueba = (dias) =>
  `Prueba de Pro: quedan ${dias} ${dias === 1 ? 'día' : 'días'}`;

/** "$59" — precio público de un plan, no un dato del usuario. */
// monto-ok: precio público del plan, no dato del usuario
export const mxn = (n) => `$${Number(n || 0).toLocaleString('es-MX')}`;

/**
 * Precio a mostrar de un plan para el periodo elegido.
 * Devuelve { actual, lista, esFundador, cupos, mensualEquivalente, ahorroPct }.
 */
export function precioVisible(plan, periodo) {
  if (!plan) return { actual: 0, lista: 0, esFundador: false, cupos: 0, mensualEquivalente: 0, ahorroPct: 0 };
  const anual = periodo === 'anual';
  const lista = parseFloat(anual ? plan.precio_anual : plan.precio_mensual) || 0;
  const efectivo = parseFloat(anual ? plan.precio_efectivo_anual : plan.precio_efectivo_mensual);
  const actual = Number.isFinite(efectivo) ? efectivo : lista;
  const listaMensual = parseFloat(plan.precio_mensual) || 0;
  const efectivoMensual = parseFloat(plan.precio_efectivo_mensual);
  const mensualBase = Number.isFinite(efectivoMensual) ? efectivoMensual : listaMensual;
  return {
    actual,
    lista,
    esFundador: actual < lista,
    cupos: parseInt(plan.cupos_fundador_restantes, 10) || 0,
    mensualEquivalente: anual ? Math.round(actual / 12) : actual,
    ahorroPct: anual && mensualBase > 0 ? Math.max(0, Math.round((1 - actual / (mensualBase * 12)) * 100)) : 0,
  };
}

/** "Precio fundador — quedan 312 lugares" (o el mensaje de quien ya lo tiene). */
export function textoFundador(p, yaEsFundador = false) {
  if (!p.esFundador) return '';
  if (p.cupos > 0) return `Precio fundador — quedan ${p.cupos} ${p.cupos === 1 ? 'lugar' : 'lugares'}`;
  return yaEsFundador ? 'Precio fundador — lo conservas mientras te mantengas suscrito' : 'Precio fundador';
}
